import Clock from "./clock";
import Inputs from "./inputs";
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer';
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass';
import { STORE } from "./store";


class App{
    constructor({ postprocessing }){
        this.renderer = new THREE.WebGLRenderer();
        document.body.appendChild( this.renderer.domElement );

        STORE.init();

        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 250 );
        this.clock = new Clock();
        this.inputs = new Inputs();
        this.entities = [];

        this.updateListeners = [];

        //POSTPROCESSING
        this.postprocessing = postprocessing || {};
        this.composer = new EffectComposer( this.renderer );
        this.composer.addPass(new RenderPass(this.scene,this.camera));
        Object.values(postprocessing).forEach(pass => {
            this.composer.addPass(pass);
        });

        window.addEventListener("resize", () => this.resize());
        this.resize();

        this.update();

        STORE.set("application_instance",this);
    }

    resize(){
        this.renderer.setSize( window.innerWidth, window.innerHeight );
        this.composer.setSize( window.innerWidth, window.innerHeight );
        const canvas = this.renderer.domElement;
        this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
        this.camera.updateProjectionMatrix();
    }

    update(){
        this.clock.update();
        for (let i = this.updateListeners.length-1; i>=0; i--) {
            this.updateListeners[i]();
        }
        for (let i = this.entities.length-1; i>=0; i--) {
            this.entities[i].update();
        }
        this.composer.render();
        requestAnimationFrame(()=> this.update())
    }


    destroyEntity(entity){
        this.scene.remove(entity.root);
        this.entities = this.entities.filter(item => item !== entity);
    }
}

Object.defineProperty(App, "instance", {
    get : function(){ return STORE.get("application_instance") },
});

export { App };